import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface GenerateAttendanceCSVParams {
  classId: string;
  showBalance: boolean;
}

export const generateAttendanceCSV = async (
  params: GenerateAttendanceCSVParams,
) => {
  try {
    const resp = await baseAPI.post<Blob>('/attendance/generate-csv', params, {
      responseType: 'blob',
    });
    return resp.data;
  } catch (error: any) {
    // If it's a blob error response, try to parse it as text to get the error message
    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      const errorJson = JSON.parse(errorText);
      throw new Error(errorJson.error || 'Failed to generate CSV');
    }
    throw error;
  }
};

export const useGenerateAttendanceCSVMutation = () => {
  return useMutation({
    mutationFn: generateAttendanceCSV,
  });
};
